var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AboutList',{attrs:{"tableData":_vm.tableData,"name":"Cancel"},on:{"isCollect":_vm.isCollect,"init":_vm.init}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }